import styled from 'styled-components';

export const StyledIcon = styled.div`
  background-color: #4385f5;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
